import { IAuditLogFilterParams } from '../../types/api/request/auditlogrequest';
import {
  IAdminAuditLogDetailResponse,
  IGetAuditLogsResponse,
} from '../../types/api/response/auditlogresponse';
import axiosClient from '../axiosClient';
import { AuditLogEndpoints } from '../endpoints/auditLog';

export const AuditLogService = {
  async getAuditLogs(params: IAuditLogFilterParams): Promise<IGetAuditLogsResponse> {
    const searchParams = new URLSearchParams();

    if (params.navigation_id != null)
      searchParams.append('navigation_id', String(params.navigation_id));
    if (params.include_children != null)
      searchParams.append('include_children', String(params.include_children));
    if (params.user_id && params.user_id.length > 0)
      params.user_id.forEach((id) => searchParams.append('user_id', id));
    if (params.start_date) searchParams.append('start_date', params.start_date);
    if (params.end_date) searchParams.append('end_date', params.end_date);
    if (params.http_method) searchParams.append('http_method', params.http_method);
    if (params.status_code_min != null)
      searchParams.append('status_code_min', String(params.status_code_min));
    if (params.status_code_max != null)
      searchParams.append('status_code_max', String(params.status_code_max));
    if (params.page != null) searchParams.append('page', String(params.page));
    if (params.size != null) searchParams.append('size', String(params.size));
    if (params.sort) searchParams.append('sort', params.sort);

    const query = searchParams.toString();
    const res = await axiosClient.get<IGetAuditLogsResponse>(
      `${AuditLogEndpoints.GET_AUDIT_LOGS}${query ? `?${query}` : ''}`,
    );
    return res.data;
  },

  async getAuditLogDetail(id: number): Promise<IAdminAuditLogDetailResponse> {
    const res = await axiosClient.get<IAdminAuditLogDetailResponse>(
      AuditLogEndpoints.GET_AUDIT_LOG_DETAIL(id),
    );
    return res.data;
  },
};
